export const TASK_STREAM_CONNECTION_ERROR_MESSAGE =
  'AI task stream connection failed'
export const TASK_COMPLETION_TIMEOUT_ERROR_MESSAGE =
  'AI task completion timed out'

export const AI_TASK_COMPLETION_TIMEOUT_MS = 5 * 60_000

export const FINAL_TASK_STATUSES = new Set(['COMPLETED', 'FAILED', 'CANCELLED'])
